import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

export interface NiceInitResponse {
  authUrl: string;
  state: string;
}

export interface NiceVerifyResponse {
  verifiedName: string;
  mobileNo: string;
  niceVerificationToken: string;
}

@Injectable({ providedIn: 'root' })
export class NiceVerificationApiService {
  private readonly http = inject(HttpClient);

  async init(): Promise<NiceInitResponse> {
    return firstValueFrom(
      this.http.post<NiceInitResponse>('/nice/init', {}),
    );
  }

  async verify(
    webTransactionId: string,
    state: string,
  ): Promise<NiceVerifyResponse> {
    return firstValueFrom(
      this.http.post<NiceVerifyResponse>('/nice/verify', {
        webTransactionId,
        state,
      }),
    );
  }
}
